import React, { createContext, ReactNode, useContext, useReducer } from 'react';

import {
  BreederAdminsAction,
  breederAdminsInitState,
  breederAdminsReducer,
  BreederAdminsState,
} from 'dogpark/reducers/breederAdmins/breederAdminsReducer';

type DispatchBreederAdmins = (action: BreederAdminsAction) => void;

const BreederAdminsContext = createContext<
  { state: BreederAdminsState; dispatch: DispatchBreederAdmins } | undefined
>(undefined);

interface BreederAdminsProviderProps {
  children: ReactNode;
  reducerInitialState?: BreederAdminsState;
}

export function BreederAdminsProvider(props: BreederAdminsProviderProps) {
  const { children, reducerInitialState } = props;
  const initialState = reducerInitialState ?? breederAdminsInitState;

  const [state, dispatch] = useReducer(breederAdminsReducer, initialState);

  return (
    <BreederAdminsContext.Provider value={{ state, dispatch }}>
      {children}
    </BreederAdminsContext.Provider>
  );
}

export function useBreederAdminsContext() {
  const context = useContext(BreederAdminsContext);
  if (!context)
    throw new Error(
      'useBreederAdminsContext must be used within a BreederAdminsProvider',
    );
  return context;
}
